/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'team-central.give-jira-kudos.created.description.flag': 'Vores Workplace Experience-team vil nu behandle din gaveanmodning. ✨',
  'team-central.give-jira-kudos.created.title.flag': 'Ros blev oprettet',
  'team-central.give-jira-kudos.creation.failed.description.flag': 'Vi kunne ikke oprette din ros eller sende gaven. Prøv at oprette en separat supportanmodning på <a>go/kudos</a>.',
  'team-central.give-jira-kudos.creation.failed.title.flag': 'Noget gik galt',
  'team-central.give-kudos.button': 'Giv ros',
  'team-central.give-kudos.close-button.label': 'Luk skuffe',
  'team-central.give-kudos.confirm-close.title': 'Bekræft Luk',
  'team-central.give-kudos.created.description.flag': 'Din ros blev sendt. <a>Se ros</a>',
  'team-central.give-kudos.created.title.flag': 'Ros blev oprettet',
  'team-central.give-kudos.creation.failed.description.flag': 'Vi kunne ikke oprette din ros.',
  'team-central.give-kudos.creation.failed.title.flag': 'Noget gik galt',
  'team-central.give-kudos.error-icon.label': 'Fejl',
  'team-central.give-kudos.success-icon.label': 'Succes',
  'team-central.give-kudos.unsaved.warning': 'Ændringer, du har foretaget, gemmes ikke.',
  'team-central.give-kudos.unsaved.warning.cancel': 'Annuller',
  'team-central.give-kudos.unsaved.warning.close': 'Luk'
};